/**
 * @author Fernando Ruano
 * @file index.js
 * @description Glucometry Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { glucometry: glucometryEndpoints } = endpoints;

export class GlucometryService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Create Glucometry
   * @param { Object } data - Glucometry data.
   * @return { promise } - The glucometry promise object.
   */
  createGlucometry = async (data) => {
    const body = { ...data };
    const url = glucometryEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Get Glucometry list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get glucometry list.
   */
  getGlucometry = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = glucometryEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get Glucometry times list with pagination
   * @return { Object } - Get glucometry times list.
   */
  getGlucometryTimes = async () => {
    const url = `${glucometryEndpoints.base}/listGlucometryTimes`;
    return this.http.get(url);
  };

  /**
   * Get Glucometry info by id
   * @param { string } id - Glucometry id.
   * @return { Object } - Get glucometry list.
   */
  getGlucometryById = async (id) => {
    const url = `${glucometryEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Get Glucometry info by patient id
   * @param { string } id - Patient id.
   * @return { Object } - Get glucometry list.
   */
  getGlucometryByPatientId = async (id) => {
    const url = `${glucometryEndpoints.base}/findGlucometryByPatientId/${id}`;
    return this.http.get(url);
  };

  /**
   * Delete Glucometry by id
   * @param { string } id - Glucometry id.
   * @return { Object } - Get glucometry list.
   */
  deleteGlucometryById = async (id) => {
    const url = `${glucometryEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update Glucometry
   * @param { Object } data - Glucometry data.
   * @param { object } id - Glucometry id.
   * @return { promise } - The Glucometry promise object.
   */
  updateGlucometry = async (data, id) => {
    const body = { ...data };
    const url = `${glucometryEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new GlucometryService(externalConnector);
